import { useEffect } from 'react';
import { prop } from 'ramda';
import { useUserSelector } from 'js/store/hooks';
import { useGetCasinoDepositLimitsSettings } from 'server';
import { FORM_FIELD_TYPE } from 'js/components/common/Form/constants';

import * as actions from '../../../store/actions';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../../../store';

export const useDepositLimitsSettings = () => {
    const dispatch = useDynamicReducerDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const fields = useDynamicReducerSelector(prop('fields'));
    const getCasinoDepositLimitsSettings = useGetCasinoDepositLimitsSettings();
    const depositLimitsField = fields.find(field => field.type === FORM_FIELD_TYPE.DEPOSIT_LIMITS);

    useEffect(() => {
        if (isLoggedIn) {
            return;
        }

        if (depositLimitsField?.active) {
            (async () => {
                const settings = await getCasinoDepositLimitsSettings();

                dispatch(actions.setLimitsSettings('deposit', settings));
            })();
        }
    }, [isLoggedIn, dispatch, depositLimitsField, getCasinoDepositLimitsSettings]);
};
